export function base64ToBytes(base64) {
    if (!isValidBase64(base64)) {
        console.log("A string fornecida não é uma base64 válida.");
        return base64;
    }
    const binString = atob(base64);
    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
    return new TextDecoder().decode(bytes);
}

function isValidBase64(base64) {
    const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    return base64Regex.test(base64);
}